import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'miq-count-badge',
  template: `
    <ng-container *ngIf="counter$ | async as count">
      <span class="badge" *ngIf="count">{{ count }}</span>
    </ng-container>
  `,
  standalone: false,
})
export class CountBadgeComponent {
  @Input() counter$: Observable<number>;
}
